'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024 from "./presto.types$.js";
import * as $j_presto$002etypes$0024$002dSite$002dId$0024 from "./presto.types$-Site-Id$.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024 from "./presto.types$-Two-Factor-Auth-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$3(outer) {
  this.bB3 = null;
  this.bB1 = null;
  this.bB2 = false;
  this.bAZ = null;
  this.bB0 = false;
  this.bB4 = false;
  this.bB5 = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bB3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$3 as $c_Lpresto_TwoFactorAuthView$$anon$3 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$3;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$3() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$3 as $h_Lpresto_TwoFactorAuthView$$anon$3 };
$h_Lpresto_TwoFactorAuthView$$anon$3.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.bB3;
});
$p.t = (function() {
  if ((!this.bB2)) {
    this.bB1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("tfa", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("sites", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bB2 = true;
  }
  return this.bB1;
});
$p.ad = (function() {
  if ((!this.bB0)) {
    this.bAZ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024.$m_Lpresto_types$TwoFactorAuthId$().vb(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024.$m_Lpresto_types$TwoFactorAuthType$().adn(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25($j_presto$002etypes$0024$002dSite$002dId$0024.$m_Lpresto_types$SiteId$().sC()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bB0 = true;
  }
  return this.bAZ;
});
$p.v = (function() {
  if ((!this.bB5)) {
    this.bB4 = false;
    this.bB5 = true;
  }
  return this.bB4;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_TwoFactorAuthView$$anon$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$3, "presto.TwoFactorAuthView$$anon$3", ({
  SN: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$3 as $d_Lpresto_TwoFactorAuthView$$anon$3 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$3.js.map
